// extracted by mini-css-extract-plugin
export default {"root":"EmptyAuth_root__G-FZN","content":"EmptyAuth_content__8gAKR","info":"EmptyAuth_info__gGPNJ","actions":"EmptyAuth_actions__xmsS7"};